import { useNavigate, useLocation, Navigate } from "react-router-dom";
import React, { useState, useEffect, useRef } from 'react';
import { Helmet } from "react-helmet";
import Header from '../body_root/header';
import Footers from '../body_root/footer';
import Navbar from '../body_root/Navbar';
import './services.css';
import { Toast } from '../components_root/ToastContext';
import { MdCall, MdCode, MdEditDocument, MdFace, MdKey, MdKeyboard, MdLocationCity, MdOutlinePhoneAndroid, MdPhoneAndroid, MdPictureAsPdf, MdQrCode } from "react-icons/md";
export const seo = {
    title: "Viabig Services | Free & Premium Online Tools for Productivity, SEO & File Conversion",
    description: "Discover Viabig's free and premium online services including word counter, image to PDF, favicon generator, SEO analyzers, text utilities, and more. Enhance productivity with powerful tools for students, writers, developers, and businesses.",
    keywords: "viabig services, free online tools, premium tools, seo tools, text utilities, file converters, image to pdf, favicon generator, word counter, productivity tools, online converters",
    url: "https://viabig.com/services",
    image: "https://viabig.com/assets/logo.png"
};
export default function Services() {
    const [text, setText] = useState("");
    const { Toastshow } = Toast();
    const navigate = useNavigate();
    return (
        <div>
            <Header />
            <Helmet>
                <title>{seo.title}</title>
                <meta name="description" content={seo.description} />
                <meta name="keywords" content={seo.keywords} />
                <meta property="og:title" content={seo.title} />
                <meta property="og:description" content={seo.description} />
                <meta property="og:image" content={seo.image} />
                <meta property="og:url" content={seo.url} />
            </Helmet>

            <div className="container_roots">
                <div className="container_size p-3">
                    <h2 className="text-xl font-bold mb-4">Products</h2>
                    <div className='post-container'>

                        <div className='ui-grid-100'>
                            {/* <div className=" ui-items items-back p-1 text-h2 bold border cursor rounded-md center">
                                <table>
                                    <tr>
                                        <td width={30}> <MdLocationCity className="icon" /></td>
                                        <td>
                                            <div onClick={() => navigate('/')} >Properties</div>
                                        </td>
                                    </tr>
                                </table>
                            </div> */}
                                <div className=" ui-items items-back p-1 text-h2 bold border cursor rounded-md center">
                                <table>
                                    <tr>
                                        <td width={30}> <MdCode className="icon" /></td>
                                        <td>
                                            <div onClick={() => navigate('/software')} >Software</div>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                           
                            <div className=" ui-items items-back p-1 text-h2 bold border cursor rounded-md center">
                                <table>
                                    <tr>
                                        <td width={30}> <MdQrCode className="icon" /></td>
                                        <td>
                                            <div onClick={() => window.location.href = "https://callqr.com"} >CallQR</div>
                                        </td>
                                    </tr>
                                </table>
                            </div>

                        </div>
                    </div>

                </div>
                <div className="container_size p-3">
                    <h2 className="text-xl font-bold mb-4">Free Services Tools</h2>
                    <div className='post-container'>

                        <div className='ui-grid-100'>
                                   <div className=" ui-items items-back p-1 text-h2 bold border cursor rounded-md center">
                                <table>
                                    <tr>
                                        <td width={30}> <MdCall className="icon" /></td>
                                        <td>
                                          <div onClick={() => navigate('/phonebook')} >Phonebook</div>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                                   <div className=" ui-items items-back p-1 text-h2 bold border cursor rounded-md center">
                                <table>
                                    <tr>
                                        <td width={30}> <MdPictureAsPdf className="icon" /></td>
                                        <td>
                                          <div onClick={() => navigate('/image-to-pdf')} >Image to  pdf</div>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                                        <div className=" ui-items items-back p-1 text-h2 bold border cursor rounded-md center">
                                <table>
                                    <tr>
                                        <td width={30}> <MdFace className="icon" /></td>
                                        <td>
                                          <div onClick={() => navigate('/favicon-generator')} >Favicon  </div>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                                       <div className=" ui-items items-back p-1 text-h2 bold border cursor rounded-md center">
                                <table>
                                    <tr>
                                        <td width={30}> <MdEditDocument className="icon" /></td>
                                        <td>
                                          <div  onClick={() => navigate('/word-counter')} >Word counter</div>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                                <div className=" ui-items items-back p-1 text-h2 bold border cursor rounded-md center">
                                <table>
                                    <tr>
                                        <td width={30}> <MdKeyboard className="icon" /></td>
                                        <td>
                                          <div onClick={() => navigate('/typing-master')} >Typing master</div>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                           
                        </div>
                    </div>

                </div>
            </div>

            <Footers />
            <Navbar />
        </div>
    );
}
